<template>
<div id="app">
  <!-- Lien d'évitement pour l'accessibilité - doit être le premier élément tabulable -->
  <a href="#main-content" class="skip-link" v-if="connected">
    {{ $t('Webheader.skip_to_main_content') }}
  </a>
  <!-- <f7-statusbar :theme="statusColor"></f7-statusbar> -->
  <left-panel v-if="connected" :context="context"></left-panel>
  <right-panel v-if="connected"></right-panel>
  <f7-views>
    <f7-view :domCache="false" :uniqueHistory="false" id="main-view" main :url="url">
      <web-header v-if="connected && !isSmartphoneOS"
        :key="'web-header-' + webheaderKey"
        :context="context">
      </web-header>
      <mobile-header v-if="connected"
        :context="context">
      </mobile-header>
      <f7-pages :class="connected  ? 'marginHomepageLargeScreen': ''">

        <div ref="toastContainer" style="
      position: fixed;
      bottom: 20px;
      right: 20px;
      z-index: 1055;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      gap: 10px;
      pointer-events: none;
    ">
        </div>
      </f7-pages>
    </f7-view>
  </f7-views>

  <cm-popups></cm-popups>

  <user-guide></user-guide>

</div>
</template>

<script>
// import LeftPanel from '@/components/leftpanel/CMLeftPanel.vue'
// import enrollMessage from '@/components/common/enrollMessage.vue'
// import FormDevis from '@/components/forms/CMDevis.vue'
// import FormReglament from '@/components/forms/CMReglament.vue'
// import dynamicStyleMixin from './mixins/dynamicStyleMixin'
// import {loadPage} from '@/helpers/routing'
import conf from './config/config.dev.js'

import WebHeader from '@/components/menus/WebHeader.vue'
import MobileHeader from '@/components/menus/MobileHeader.vue'
import LeftPanel from '@/components/menus/MobileLeftPanel.vue'
import RightPanel from '@/components/common/RightPanel.vue'

import design from '@/design/design.json'

import networkMixin from './mixins/networkMixin'

import CMPopup from '@/popups/Popups.vue'
import userGuidePopovers from '@/components/common/userGuidePopovers.vue'
// import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'

import {errorMessageAlert} from '@/helpers/alert'
import {loadPage, reloadPage} from '@/helpers/routing'
import moment from "moment-timezone";

/* eslint-disable no-tabs */
/* eslint-disable indent */
export default {
  name: 'VOPDiamond',
  mixins: [networkMixin], //  dynamicStyleMixin],
  components: {
    // 'left-panel': LeftPanel,
    // 'cm-devis': FormDevis,
    // 'cm-reglament': FormReglament,
    // 'enroll-message': enrollMessage,
    // 'bottom-toolbar': bottomToolbar,
    'cm-popups': CMPopup,
    'left-panel': LeftPanel,
    'mobile-header': MobileHeader,
    'right-panel': RightPanel,
    'user-guide': userGuidePopovers,
    'web-header': WebHeader
  },
  data: () => {
    return {
      context: 'VOP',
      design: design,
      service: '',
      connected: false,
      toastList: [],
      flagTOOLBOX: conf.visual === 'TOOLBOX',
      homepageSelected: false,
      webheaderKey: false,
      defaultService: 'VOP',
      surveyConnectedMins: 0,
      surveyConnectedSecs: 10,
      url: '',
      timezone: '+00:00',
      otpIndexEngine: 0,
      otpNbTry: 0,
      otpNbMaxTry: 10,
      otpData: {}
    }
  },
  created () {
    this.timezone = moment.tz.guess()
    let that = this
    var data = this.getJsonFromUrl(window.location.href)
    if (data.loginSSO === '1' && data.login && data.OTP) {
      this.loginOTP(data)
      // for (let i = 0; i < this.$engine.engines.length; i++) {
      //   const engine = this.$engine.get(i)
      //   if (engine.common.network.state === 'offline') {
      //     continue
      //   }
      //
      //   const resp = await engine.get(i).auth.loginOTP({ email: data.login, otp: data.OTP })
      //   that.details = {}
      //   if (resp.status === 200) {
      //     setTimeout(function () { /* Timeout for letting time to load vue components */
      //       engine.firstOn().user.setIsFirstLogin('0')
      //       // that.connected = true
      //       // loadPage(that, {url: '/home/'})
      //     }, 0)
      //   }
      // }
      // window.location = window.location.href.split('?')[0]
    } else {
      if (data.OTP && data.email && data.ressource) {
        this.url = '/OTP/' + data.email + '/' + data.OTP + '/' + data.ressource
      } else if (data.sendDocumentsFromApplication === '1') {
        this.url = '/OTP/' + data.email + '/' + data.OTP + '/sendDocumentsFromApplication'
      } else if (data.loading === '1') {
        this.url = '/loading/'
      } else if (data.Token) {
        this.url = '/Register/' + (data.Token ? data.Token : '-1') + '/' + (data.Email ? data.Email : '-1')
      } else if (this.$engine.firstOn().applicationMode === 'standard') {
        this.url = '/login/'
      } else {
        this.url = ''
      }
      /** TLV - TBR 27/11/2017
       * Affichage du menu de gauche seulement quand un service est actif,
       * Quand il n'y a pas de service sélectionné (sur la page de connexion par exemple),
       * Le menu de gauche n'est pas affiché
       */
      this.$bus.$on('service:change', () => {
        this.service = this.$engine.firstOn().user.currentService.name
        this.$bus.$emit('refresh-cache-menu')
      })
      this.$bus.$on('refresh-cache-menu', () => {
        this.service = this.$engine.firstOn().user.currentService.name
      })
      this.$bus.$on('reset-webheader', () => {
        that.webheaderKey = !that.webheaderKey
      })
      this.$bus.$off('reload-app')
      this.$bus.$on('reload-app', () => {
        that.$engine.firstOn().setService(that.getContext())
        that.context = that.$engine.firstOn().getService()
        that.webheaderKey = !that.webheaderKey
        that.$bus.$emit('reload-homepage')
        loadPage(that, {
          url: (flagTOOLBOX ? '/homecarrousel/' : '/home/') + that.context
        })
        that.$bus.$emit('reset-selected-menu')
      })
    }
  },
  mounted () {
    this.$root.showToast = this.showToast
    let that = this
    this.$bus.$on('login', function (login) {
      if (login) {
        // TLV 08/02/2021 : showing web header unless we are using an iframe
        if (login !== 'iframe') {
          that.connected = true
        }
        for (let i = 0; i < this.$engine.length; i++) {
          if (that.$engine.get(i).common.network.state === 'online') {
            that.$refs.toastContainer?.querySelector('#engine-' + i)?.remove()
          }
        }
        if (this.$engine.firstOn().user.currentService.id != null) {
          this.$bus.emit('service:change', that.$engine.firstOn().services.getServiceIdByName(that.defaultService))
        } else {
          this.$bus.emit('service:change', that.defaultService)
          this.$engine.firstOn().user.currentService.name = that.defaultService
          this.$engine.firstOn().user.currentService.id = this.$engine.firstOn().services.getServiceIdByName(that.defaultService)
        }
      }
      if (that.$engine.firstOn().user.getIsFirstLogin() === '1' || that.$engine.firstOn().user.get().isFirstLogin === '1') {
        that.$bus.$emit('popup-change-password-data')
      }
    })
    this.$bus.$on('logout', function (force) {
      this.$bus.$emit('close-all-popups')
      this.$engine.firstOn().auth.logout(force).then(response => {
        that.connected = false
        this.$engine.firstOn().user.currentService.name = ''
        this.$bus.$emit('service:change', '')
        reloadPage(that, {
          url: '/login/',
          force: true,
          ignoreCache: true
        })
      })
    })
    this.$bus.$on('silo-down', function (silo) {
      let title = that.$i18n.t('common.alerts.engine_down_title')
      let desc = that.$i18n.t('common.alerts.engine_down_desc', { name: silo.name })
      that.$root.showToast(title, desc, 'warning', {id: silo.id})
      if (silo.default) {
        that.$bus.emit('logout', (true))
      }
    })
    this.$bus.$on('engines-ping', function () {
      that.$engine.ping()
    })
    this.$bus.$on('isOnHomepage', function (currentlyOnHomepage) {
      that.homepageSelected = currentlyOnHomepage
    })

    for (let key in this.cssVars) {
      document.documentElement.style.setProperty(key, this.cssVars[key])
    }
    this.surveyConnected()
  },
  computed: {

    cssVars () {
      return {
        // BOUTONS
        '--actionButtonSimpleGris': this.design.global.actionButtonSimpleGris,
        '--actionButtonColorBlue': this.design.global.actionButtonColorBlue,
        '--borderButtonColorBlue': this.design.global.borderButtonColorBlue,
        '--actionButtonColorViolet': this.design.global.actionButtonColorViolet,
        '--borderButtonColorViolet': this.design.global.borderButtonColorViolet,
        '--actionBackgroundColor':  this.design.global.actionBackgroundColor,
        '--actionBackgroundWhite':  this.design.global.actionBackgroundWhite,
        '--actionBackgroundBlue': this.design.global.actionBackgroundBlue,
        '--borderRadius': this.design.global.borderRadius,
        // TEXTE
        '--actionTextColorWhite': this.design.global.actionTextColorWhite,
        '--actionTextColorBlue': this.design.global.actionTextColorBlue,
        '--actionTextColorBlack': this.design.global.actionTextColorBlack,
        '--actionTextColorWhiteHover': this.design.global.actionTextColorWhiteHover,
        // POLICE
        '--fontFamily': this.design.global.fontFamily,
        '--fontSize': this.design.global.fontSize,
        '--fontSizetitle': this.design.global.fontSizetitle,
        '--fontSizeMenu': this.design.global.fontSizeMenu,
        '--fontSizeSubMenu': this.design.global.fontSizeSubMenu,
        '--fontWeightMenu': this.design.global.fontWeightMenu,
        '--fontWeight': this.design.global.fontWeight,
        '--borderRadius': this.design.global.borderRadius,
        // Couleur des tableaux et onglets actifs
        "--actionButtonSimpleGrisBleu": this.design.global.actionButtonSimpleGrisBleu,
        // header and nav menu
        "--headFamilyFont": this.design.menu.headFamilyFont,
        "--headbandColor": this.design.menu.headbandColor,
        "--headbandColorHover": this.design.menu.headbandColorHover,
        "--headbandColorHover2": this.design.menu.headbandColorHover2,
        "--headbandTextColor": this.design.menu.headbandTextColor,
        "--headbandTextColorHover": this.design.menu.headbandTextColorHover,
        "--headbandTextColorHover2": this.design.menu.headbandTextColorHover2,
        "--headbandLogoLong": this.design.menu.headbandLogoLong,
        "--homepageLogo": this.design.menu.homepageLogo,
        // popin login
        "--textLoginColor": this.design.login.textLoginColor,
        "--textButtonLoginColor": this.design.login.textButtonLoginColor,
        "--buttonLoginColor": this.design.login.buttonLoginColor,
        "--buttonLoginColorHover": this.design.login.buttonLoginColorHover,
        "--fontImage": this.design.login.fontImag,
        "--headbandLogoLong": this.design.login.headbandLogoLong,
        //acceuil
        "--cardFontSize": this.design.acceuil.cardFontSize,
        "--cardFontWeight": this.design.acceuil.cardFontWeight,
        "--cardBckgColor": this.design.acceuil.cardBckgColor,
        "--cardIconSize": this.design.acceuil.cardIconSize,
        "--cardIconWeight": this.design.acceuil.cardIconWeight,
        "--cardRadius": this.design.acceuil.cardRadius,
        "--cardFamilyFont": this.design.acceuil.cardFamilyFont,
        //Pages Title
        "--titleFamilyPage": this.design.Page.titleFamilyPage,
        "--titleSizePage": this.design.Page.titleSizePage,
        "--titleColorPage": this.design.Page.titleColorPage,
        "--titleWeightPage": this.design.Page.titleWeightPage,
        "--fontFamilyPage": this.design.Page.fontFamilyPage,
        "--fontSizePage": this.design.Page.fontSizePage,
        "--fontColorPage": this.design.Page.fontColorPage,
        "--fontWeightPage": this.design.Page.fontWeightPage
      }
    },
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    },
    statusColor () {
      if (this.online) return ''
      return 'red'
    },
    surveyConnectedTimer () {
      return ((this.surveyConnectedMins * 60) + this.surveyConnectedSecs) * 1000
    },
    titleNavBar () {
      let style = {
        'background-color': this.servicesColors.DEFAULT
      }
      if (!this.online) style['background-color'] = '#f44336'
      return style
    }
  },
  notifications: {
    showNetworkOffline: {
      type: 'error',
      title: '',
      message: 'Your device is offline'
    },
    showNetworkOnline: {
      type: 'info',
      title: '',
      message: 'Connection is now available'
    }
  },
  watch: {
    online (isOnline) {
      if (isOnline) {
        this.showNetworkOnline()
      } else {
        this.showNetworkOffline()
      }
    }
  },
  methods: {
    showToast (title, body, type = 'info', data = {}) {
      const toastContainer = this.$refs.toastContainer;

      if (data.id !== undefined && this.$engine.get(data.id).common.network.info.name === 'SKIP') {
        return
      }
      if (data.id === undefined || !this.toastList.map(elem => elem.id).filter(elem => elem.id !== undefined).includes(data.id)) {
        this.toastList.push({id:data.id})
      } else {
        return
      }

      if (!toastContainer) {
        console.error('Toast container not found.');
        return;
      }

      const toast = document.createElement('div');
      toast.className = 'toast';
      toast.setAttribute('role', 'alert');
      toast.setAttribute('aria-live', 'assertive');
      toast.setAttribute('aria-atomic', 'true');
      toast.setAttribute('id', 'engine-'+data.id)
      toast.style.minWidth = '250px';
      toast.style.pointerEvents = 'auto';
      toast.style.flexBasis = 'unset';

      // Ajoute la classe selon le type
      switch (type) {
        case 'success':
          toast.classList.add('bg-success', 'text-white');
          break;
        case 'error':
          toast.classList.add('bg-danger', 'text-white');
          break;
        case 'warning':
          toast.classList.add('bg-warning', 'text-dark');
          break;
        case 'info':
        default:
          toast.classList.add('bg-info', 'text-white');
          break;
      }
      const humanTime = moment().tz(this.timezone).format('YYYY-MM-DD HH:mm:ss');

      toast.innerHTML = `
    <div class="toast-header">
      <strong class="mr-auto">${title}</strong>
      <small class="text-muted">${humanTime}</small>
    </div>
    <div class="toast-body">
      ${body}
    </div>
  `;

      toastContainer.appendChild(toast);

      setTimeout(() => {
        toast.classList.add('show');
        toast.style.opacity = '1';
      }, 100);

    },
    getJsonFromUrl (url) {
      if (!url) url = location.href
      var question = url.indexOf('?')
      var hash = url.indexOf('#')
      if (hash === -1 && question === -1) return {}
      if (hash === -1) hash = url.length
      var query = (question === -1 || hash === question + 1) ? url.substring(hash) : url.substring(question + 1, hash)
      var result = {}
      query.split('&').forEach(function (part) {
        if (!part) return
        part = part.split('+').join(' ') // replace every + with space, regexp-free version
        var eq = part.indexOf('=')
        var key = eq > -1 ? part.substr(0, eq) : part
        var val = eq > -1 ? decodeURIComponent(part.substr(eq + 1)) : ''
        var from = key.indexOf('[')
        if (from === -1) result[decodeURIComponent(key)] = val
        else {
          var to = key.indexOf(']', from)
          var index = decodeURIComponent(key.substring(from + 1, to))
          key = decodeURIComponent(key.substring(0, from))
          if (!result[key]) result[key] = []
          if (!index) result[key].push(val)
          else result[key][index] = val
        }
      })
      return result
    },
    async loginOTP (data) {
      this.otpData = data
      const maxAttempts = 10
      const interval = 1000
      let connected = false
      while (this.otpIndexEngine < this.$engine.engines.length && this.otpNbTry < maxAttempts) {
        try {
          let resp = await this.$engine.get(this.otpIndexEngine).auth.loginOTP({ email: this.otpData.login, otp: this.otpData.OTP })
          if (resp.status === 200) {
            this.$engine.get(this.otpIndexEngine).user.setIsFirstLogin('0')
            connected = true
            this.otpIndexEngine += 1
            this.otpNbTry = 0
          }
        } catch (e) {
          let resp = e.response
          if (resp.status && (this.otpNbTry + 1) < this.otpNbMaxTry) {
            this.otpNbTry += 1
            await new Promise(r => setTimeout(r, interval))
          } else {
            this.otpIndexEngine += 1
            this.otpNbTry = 0
          }
        }
      }
      if (connected) {
        window.location = window.location.href.split('?')[0]
      }
    },
    async tryLogin () {
    },
    surveyConnected () {
      let that = this
      setTimeout(function () {
        if (that.connected && that.$engine.firstOn().common.network.isSessionExpired()) {
          that.$engine.firstOn().user.manageSession()
          .then(resp => {
          })
          .catch(err => {
            errorMessageAlert(err, that, true)
          })
          .finally(() => {
            that.surveyConnected()
          })
        } else {
          that.surveyConnected()
        }
      }, that.surveyConnectedTimer)
    }
  }
}
</script>

<style media="screen">
/* Lien d'évitement pour l'accessibilité */
.skip-link {
  position: fixed;
  top: -40px;
  left: 6px;
  z-index: 9999;
  color: white;
  background-color: #000;
  padding: 8px 16px;
  text-decoration: none;
  border-radius: 0 0 4px 4px;
  font-weight: bold;
  transition: top 0.3s;
}

.skip-link:focus {
  top: 0;
  color: white;
  text-decoration: underline;
}

.hiddenBlock {
  display: none;
}

@media (min-width: 850px) {
  .marginHomepageLargeScreen {
    max-height: calc(100% - 80px);
  }
}

</style>
